import { useCallback, useEffect, useState } from 'react';
import { useAuth } from '../../../context/auth-context.jsx';
import { adminApi } from '../../../lib/admin-api/index.js';
import { mapCommissionPlansResponseToDto } from '../dto/commission-plans-list.dto.js';
import { buildCommissionPlansTableModel } from '../model/commission-plans-list.model.js';

export function useCommissionPlansList() {
  const { token } = useAuth();
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');
  const [showAll, setShowAll] = useState(false);

  const loadPlans = useCallback(async () => {
    setIsLoading(true); setError('');
    try {
      const response = await adminApi.getCommissionPlans(token, { showAll });
      const dto = mapCommissionPlansResponseToDto(response);
      setRows(buildCommissionPlansTableModel(dto));
    } catch (requestError) {
      setRows([]); setError(requestError.message || 'Failed to load commission plans');
    } finally { setIsLoading(false); }
  }, [token, showAll]);

  useEffect(() => { loadPlans(); }, [loadPlans]);

  const reload = useCallback(() => { loadPlans(); }, [loadPlans]);

  return { rows, isLoading, error, reload, showAll, setShowAll };
}
